// @ts-strict-ignore
import { KeyedResource } from './keyed.resource';

export class PageResource extends KeyedResource {
  private pageNameImpl: string;

  constructor(args: any, pageName?: string) {
    super(args);
    const self: any = this;
    self.resourceType = 'page';
    self.pageNameImpl = pageName || this.uiResourceName;
  }

  public get pageName() {
    return this.pageNameImpl;
  }
}
